import axios from 'axios';
import { Claim, Config } from '../types';

const API_BASE = '/api';

export const api = {
  // Claims
  getClaims: (): Promise<Claim[]> =>
    axios.get(`${API_BASE}/claims`).then(res => res.data),
    
  getClaim: (id: string): Promise<Claim> =>
    axios.get(`${API_BASE}/claims/${id}`).then(res => res.data),
    
  updateClaimStatus: (id: string, status: Claim['status']): Promise<Claim> =>
    axios.put(`${API_BASE}/claims/${id}/status`, { status }).then(res => res.data),

  updateClaim: (id: string, updates: Partial<Claim>): Promise<Claim> =>
    axios.put(`${API_BASE}/claims/${id}`, updates).then(res => res.data),

  // Configuration
  getConfig: (): Promise<Config> =>
    axios.get(`${API_BASE}/config`).then(res => res.data),
    
  updateConfig: (config: Config): Promise<Config> =>
    axios.put(`${API_BASE}/config`, config).then(res => res.data),
};